export enum CollectionVisibility {
	PUBLIC = "PUBLIC",
	SEMI_PUBLIC = "SEMI_PUBLIC",
}
